module.exports = __webpack_public_path__ + "static/media/search.0bed9502.svg";